var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
var BreadcrumbAnchor = /** @class */ (function (_super) {
    __extends(BreadcrumbAnchor, _super);
    function BreadcrumbAnchor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BreadcrumbAnchor.prototype, "safeId", {
        get: function () {
            var id = this.id || this.title;
            return id
                .replace(/\s*/g, '')
                .replace(/[^A-Z0-9_|\-|\:|\.]/gi, '');
        },
        enumerable: true,
        configurable: true
    });
    BreadcrumbAnchor.prototype.mounted = function () {
        window.$bus.$emit("BreadcrumbAnchor.mounted");
    };
    BreadcrumbAnchor.prototype.unmounted = function () {
        window.$bus.$emit("BreadcrumbAnchor.unmounted");
    };
    __decorate([
        Prop({ type: String })
    ], BreadcrumbAnchor.prototype, "id", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], BreadcrumbAnchor.prototype, "title", void 0);
    __decorate([
        Prop({ type: String })
    ], BreadcrumbAnchor.prototype, "linkClass", void 0);
    BreadcrumbAnchor = __decorate([
        Component({
            name: "BreadcrumbAnchor"
        })
    ], BreadcrumbAnchor);
    return BreadcrumbAnchor;
}(Vue));
export default BreadcrumbAnchor;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/BreadcrumbAnchor.vue
// module id = 56
// module chunks = 0 1 2 3 4 5 6 10 12